import React, { Component } from 'react'
import { Collapse } from 'antd'
import {connectSearchBox} from 'react-instantsearch/connectors';
import { Configure, InstantSearch, Hits, PoweredBy, RefinementList, Pagination, CurrentRefinements, ClearRefinements } from 'react-instantsearch/dom';

const Panel = Collapse.Panel;

import Order from './Order'

const VirtualSearchBox = connectSearchBox(() => null);

class ProductSearch extends Component {

  constructor(props) {
    super(props);

    this.state = {
      searchState: null
    }
  }

  handleStateChange = (searchState) => {
    this.setState({searchState});
  };

  render() {
    const { searchQuery, orderSearchConfig } = this.props;
    const { searchState } = this.state;
    return (
      <InstantSearch
        {...orderSearchConfig}
        onSearchStateChange={ this.handleStateChange }
        searchState={{
          ...searchState,
          query: searchQuery
        }}
      >
        <VirtualSearchBox/>
        <Configure hitsPerPage={ 5 }/>
        <Collapse bordered={false}>
          <Panel header="Filter" key="1" >
            <CurrentRefinements/>
            <ClearRefinements/>
            <RefinementList attribute="status" />
            <RefinementList attribute="payment_status" />
          </Panel>
        </Collapse>
        <Hits hitComponent={Order} />
        <div className="search-pagination">
          <Pagination />
        </div>
        <PoweredBy />
      </InstantSearch>
    )
  }
}

export default ProductSearch